//import
import React, { useEffect, useState } from 'react';
import { Tag, Table, Space, Button, Pagination, Input } from 'antd';
import { GetAllRetreats } from '../../../api/AdminService';
import { Link } from 'react-router-dom';
import LoadingPage from '../../../Components/LoadingPage/LoadingPage';
const titleStyle = { color: '#4A5568' };
const columns = [
  {
    title: <span style={titleStyle}>Name</span>,
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: <span style={titleStyle}>Remaining Slot</span>,
    dataIndex: 'remainingSlots',
    key: 'remainingSlots',
    render: (_, record) => `${record.remainingSlots}/${record.capacity}`,
  },
  {
    title: <span style={titleStyle}>Created By</span>,
    dataIndex: 'createdBy',
    key: 'createdBy',
    render: (createdBy) => `${createdBy.firstName} ${createdBy.lastName}`,
  },
  {
    title: <span style={titleStyle}>Status</span>,
    dataIndex: 'status',
    key: 'status',
    render: (status) => (
      <Tag color={status === 'Open' ? 'green' : (status === 'Close' ? 'red' : (status === 'Active' ? 'blue' : 'gray'))}>
        {status}
      </Tag>
    ),
  },
  {
    title: <span style={titleStyle}>Start Date</span>,
    dataIndex: 'startDate',
    key: 'startDate',
  },
  {
    title: <span style={titleStyle}>Action</span>,
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <Link to={`/Admin/Retreat/${record.id}`}>
          <Button type="primary">
            Detail
          </Button>
        </Link>
      </Space>
    ),
  },
]
const AdminRetreat = () => {
  const [dataSrc, setDataSrc] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [name, setName] = useState('');
  const getRetreats = (page) => {
    try {
      GetAllRetreats(page, name).then(res => {
        if (res.status === 200) {
          console.log(res.data.data)
          setDataSrc(res.data.data)
          setTotalPage(res.data.pagination.totalRow)
          setLoading(false)
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getRetreats(currentPage - 1);
  }, [currentPage, name]);

  return (
    <div
      style={{
        padding: 24,
        minHeight: '100vh',
        Width: '100%',
      }}
    >
      <h1 style={{ fontSize: '2.5rem', marginBottom: 16, fontWeight: 'bold', textAlign: 'left', color: '#003366' }}>ALL RETREATS</h1>

      {loading ? (<LoadingPage />
      ) : (
        <>
          <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex' }}>
              <Input
                placeholder="Search by Retreat"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{ width: '200px', marginRight: '8px' }}
              />

              <Button type="primary" href="/Admin/Retreat/AddRetreat">
                Create Retreat
              </Button>
            </div>
            <Pagination
              current={currentPage}
              pageSize={12}
              total={totalPage}
              onChange={(page) => setCurrentPage(page)}
              showSizeChanger={false}
            />
          </div>

          <Table columns={columns} dataSource={dataSrc} pagination={false} />
        </>)}
    </div>
  );
};

export default AdminRetreat;